<page-content>
  <header-elitment header
                   [hasSideMenu]="true">
  </header-elitment>
  <side-menu left-menu>
    <libraries-side-menu></libraries-side-menu>
  </side-menu>
  <error-401 *ngIf="is401"></error-401>
  <error-404 *ngIf="is404"></error-404>
  <module-content *ngIf="!is401 && !is404"
                  [title]="pageTitle"
                  [mainActions]="mainActions">
    <div class="search-bar">
      <mat-form-field
        color="primary"
        class="">
        <input #search
               matInput
               type="text"
               maxlength="255"
               placeholder="{{ 'Filter' | translate }}">
        <mat-icon class="search-icon" (click)="triggerSearch()" matSuffix>search</mat-icon>
      </mat-form-field>
    </div>

    <exercice-category-filters [selectedCategoryIds]="selectedCategoryIds"
                               (onCategoryClicked)="onCategoryClicked($event)" />

    <div class="spacer"></div>

    <exercice-category-sorting [selectedSort]="orderBy" (onSortSelection)="onOrderBySelection($event)"></exercice-category-sorting>

    <div class="spacer"></div>

    <div class="exercice-grid" *ngIf="!isLoading" >
      <ng-container *ngFor="let exercice of dataSource.getAll()">
        <exercice-list-card
          [exerciceRow]="exercice"
          (onShowClicked)="onShowClicked(exercice)"
          (onDuplicateExerciceClicked)="onDuplicateExerciceClicked(exercice)"
          (onModifyExerciceClicked)="onModifyExerciceClicked(exercice)"
          (onDeleteExerciceClicked)="onDeleteExerciceClicked(exercice)"
          />
      </ng-container>
    </div>

<!--    <mat-table *ngIf="!isLoading" [dataSource]="dataSource">-->
<!--      <mat-header-row *matHeaderRowDef="columns"></mat-header-row>-->
<!--      <mat-row *matRowDef="let row; columns: columns"></mat-row>-->
<!--      <ng-container matColumnDef="image">-->
<!--        <mat-header-cell *matHeaderCellDef class="image-cell"></mat-header-cell>-->
<!--        <mat-cell *matCellDef="let row; let i = index" class="image-cell">-->
<!--          <img *ngIf="row.exerciceImage"-->
<!--               [src]="row.exerciceImage" />-->
<!--          <mat-icon *ngIf="!row.exerciceImage">-->
<!--            offline_bolt-->
<!--          </mat-icon>-->
<!--        </mat-cell>-->
<!--      </ng-container>-->
<!--      <ng-container matColumnDef="name">-->
<!--        <mat-header-cell *matHeaderCellDef class="name-cell">{{ 'Name' | translate }}</mat-header-cell>-->
<!--        <mat-cell *matCellDef="let row; let i = index" class="name-cell">-->
<!--          <div *ngIf="row.rights.view; else notLink">-->
<!--            <a (click)="onShowClicked(row)">{{ row.exercice.name }}</a>-->
<!--          </div>-->
<!--          <ng-template #notLink>-->
<!--            <div>{{ row.exercice.name }}</div>-->
<!--          </ng-template>-->
<!--        </mat-cell>-->
<!--      </ng-container>-->
<!--      <ng-container matColumnDef="accents">-->
<!--        <mat-header-cell *matHeaderCellDef class="accents-cell hideable-500">{{ 'Accents' | translate }}</mat-header-cell>-->
<!--        <mat-cell *matCellDef="let row; let i = index" class="accents-cell hideable-500">-->
<!--          <ng-container *ngFor="let category of row.categories">-->
<!--            <exercice-category-thumbnail *ngIf="category"-->
<!--                                         [data]="category">-->
<!--            </exercice-category-thumbnail>-->
<!--          </ng-container>-->
<!--        </mat-cell>-->
<!--      </ng-container>-->
<!--      <ng-container matColumnDef="tags">-->
<!--        <mat-header-cell *matHeaderCellDef class="accents-cell">{{ 'Tags' | translate }}</mat-header-cell>-->
<!--        <mat-cell *matCellDef="let row; let i = index" class="accents-cell">-->
<!--          <span>{{ row.exercice.tags }}</span>-->
<!--        </mat-cell>-->
<!--      </ng-container>-->
<!--      <ng-container matColumnDef="creater">-->
<!--        <mat-header-cell *matHeaderCellDef class="creater-cell">{{ 'Created_by' | translate }}</mat-header-cell>-->
<!--        <mat-cell *matCellDef="let row; let i = index" class="creater-cell">-->
<!--          <div>{{ row.creater?.firstName + ' ' + row.creater?.lastName }}</div>-->
<!--        </mat-cell>-->
<!--      </ng-container>-->
<!--      <ng-container matColumnDef="actions">-->
<!--        <mat-header-cell *matHeaderCellDef class="special-actions-cell"></mat-header-cell>-->
<!--        <mat-cell *matCellDef="let row; let i = index" class="special-actions-cell">-->
<!--          <button *ngIf="row.rights.duplicate || row.rights.edit || row.rights.delete"-->
<!--                  mat-icon-button-->
<!--                  [matMenuTriggerFor]="rowMoreMenu">-->
<!--            <mat-icon>more_vert</mat-icon>-->
<!--          </button>-->
<!--          <mat-menu #rowMoreMenu="matMenu" xPosition="before">-->
<!--            <button mat-menu-item-->
<!--                    [disabled]="!row.rights.duplicate"-->
<!--                    (click)="onDuplicateExerciceClicked(row)">-->
<!--              <mat-icon>filter_none</mat-icon>&nbsp;{{ 'Duplicate' | translate }}-->
<!--            </button>-->
<!--            <button mat-menu-item-->
<!--                    [disabled]="!row.rights.edit"-->
<!--                    (click)="onModifyExerciceClicked(row)">-->
<!--              <mat-icon>edit_outlined</mat-icon>&nbsp;{{ 'Edit' | translate }}-->
<!--            </button>-->
<!--            <button mat-menu-item-->
<!--                    [disabled]="!row.rights.delete"-->
<!--                    (click)="onDeleteExerciceClicked(row)">-->
<!--              <mat-icon>delete_outlined</mat-icon>&nbsp;{{ 'Delete' | translate }}-->
<!--            </button>-->
<!--          </mat-menu>-->
<!--        </mat-cell>-->
<!--      </ng-container>-->
<!--    </mat-table>-->
    <center-loader class="paginator-data-placeholder" *ngIf="isLoading"></center-loader>
    <mat-paginator #paginator
                   hidePageSize
                   [pageSize]="exerciseDataSource.itemsPerPage"
                   [length]="exerciseDataSource.totalItems"
                   showFirstLastButtons>
    </mat-paginator>

    <div *ngIf="exerciseDataSource?.totalItems === 0" class="legend">{{ 'No_exercice_yet' | translate }}</div>
  </module-content>
</page-content>
